import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../../cmsConfig';
import { SaveFormResponse } from '../../../types/Application/application';
import {
  CsnApplicationFullTexts,
  CsnApplicationSaveFormRequest,
  CsnApplicationStartTexts,
} from '../../../types/Application/csnApplication';

export const csnApplicationApi = createApi({
  reducerPath: 'csnApplicationApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getStartTexts: builder.query<CsnApplicationStartTexts, void>({
      query: () => `/csnApplication/getStartTexts/`,
    }),
    getFullTexts: builder.query<CsnApplicationFullTexts, void>({
      query: () => `/csnApplication/getFullTexts`,
    }),
    SaveFormCsnApplication: builder.mutation<
      SaveFormResponse,
      CsnApplicationSaveFormRequest
    >({
      query: (formData) => ({
        url: `/csnApplication/saveForm/`,
        method: 'POST',
        body: formData,
        cache: 'no-cache',
      }),
      transformResponse: (res: SaveFormResponse) => {
        return { statusCode: res.statusCode };
      },
      transformErrorResponse: (res) => {
        const { status } = res;
        return status;
      },
    }),
  }),
});

export const {
  useLazyGetStartTextsQuery,
  useLazyGetFullTextsQuery,
  useSaveFormCsnApplicationMutation,
} = csnApplicationApi;
